import * as React from 'react'
import './styles.css'

const Map = () => (
  <section className={'map-wrapper'}>
    <iframe
      src='https://app.podglobal.com/embedded/deloitte/'
      frameBorder='0'
      width='100%'
      height='100%'
      style={{
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    ></iframe>
  </section>
)

export default Map
